<template>
    <v-popover ref="popover" placement="left" @show="loadContracts" :disabled="loading">
        <div class="hover-highlight d-flex justify-content-between align-items-center" :class="{loaded: loaded}">
            <span v-if="loading" class="fas fa-spinner fa-spin"></span>
            <span v-else class="fas fa-info-circle" :class="{ 'icon': loaded }"></span>
            <div class="revenue-share-value">
                <span :class="{ 'text-muted' : !share }">{{ share ? share : '—' }}</span>%
            </div>
        </div>
        <template slot="popover">
            <div class="compact-title">{{ 'revenue.contracts' | lang}}:</div>
            <div class="contracts">
                <div v-if="receives.length <= 0 && givingContract === null">
                    <small class="text-muted">{{ 'general.none' | lang}}</small>
                </div>
                <table v-else class="compact">
                    <template v-if="givingContract">
                        <tr>
                            <th>{{ 'revenue.source' | lang}}</th>
                            <th>{{ 'revenue.gives' | lang}}</th>
                            <th>{{ 'revenue.to' | lang}}</th>
                        </tr>
                        <tr>
                            <td>{{ givingContract.givingPartyLabel }}</td>
                            <td class="text-info">{{ `${givingContract.revenue_share}%` }}</td>
                            <td>{{ givingContract.receivingPartyLabel }}</td>
                        </tr>
                    </template>
                    <template v-if="receives.length > 0">
                        <tr>
                            <th>{{ 'revenue.source' | lang}}</th>
                            <th>{{ 'revenue.receives' | lang}}</th>
                            <th>{{ 'revenue.from' | lang}}</th>
                        </tr>
                        <tr v-for="receivingContract in receives">
                            <td>{{ receivingContract.receivingPartyLabel }}</td>
                            <td class="text-success">{{ `${receivingContract.revenue_share}%` }}</td>
                            <td>{{ receivingContract.givingPartyLabel }}</td>
                        </tr>
                    </template>
                </table>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "RevenueShare",
    props: [
      'user_id',
      'share'
    ],
    data() {
      return {
        loading: false,
        loaded: false,
        receives: [],
        givingContract: null,
      }
    },
    methods: {
      loadContracts() {
        if (this.loaded || this.loading) {
          return;
        }

        this.loading = true;
        axios.get(`/manager/users/${this.user_id}/revenueContracts`).then((response) => {
          const data = response.data;
          this.receives = data.receives;
          this.givingContract = data.gives;
        }).finally(() => {
          this.loaded = true;
          this.loading = false;
          this.$nextTick().then(() => {
            this.$refs.popover.show();
          });
        });
      }
    }
  }
</script>

<style lang="scss">

    .compact-title {
        text-align: left;
        color: #777777;
        font-size: x-small;
    }

    .contracts {
        max-height: 9rem;
        overflow: auto;
    }

    .hover-highlight {
        border: 1px solid #2d2e34 !important;
        padding: .2rem .5rem;

        .text-muted {
            color: #3a3b41 !important
        }

        &:hover {
            border: 1px solid #3a3b41 !important;

            &.loaded {
                background: #3a3b41;
            }

            .icon {
                color: goldenrod;
            }
        }

        .revenue-share-value {
            font-size: 1rem;
        }
    }

    table.compact {
        font-size: small;
        color: gray;

        tr {
            text-align: left;

            td, th {
                padding-right: 1.5rem;
            }
        }
    }
</style>